import React from 'react';
import {
  ButtonGroup,
  Text,
  Divider,
  Button,
  IconButton,
  Box,
  Flex,
  Icon,
} from '@podiumhq/design-system';

const FakeConversation = () => {
  return (
    <>
      <Flex
        width="100%"
        position="relative"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box>
          <Flex
            alignItems="center"
            marginLeft="24px"
            marginTop="16px"
            marginRight="24px"
            justifyContent="space-between"
          >
            <Flex flex="1" flexDirection="column">
              <Box display="flex" alignItems="center">
                <Text fontSize="lg" display="inline" fontWeight="semibold">
                  👋 Taylor at Podium
                </Text>
                <IconButton
                  borderRadius="16px"
                  marginLeft="8px"
                  fillColor="green.base"
                  iconSize="1.5em"
                  borderWidth="0px"
                  size="xs"
                  type="MobilePhone"
                  tabIndex="-1"
                />
              </Box>
              <Text fontSize="md" color="grey.light">
                123 Address Main
              </Text>
            </Flex>

            <Box>
              <Icon
                type="Star"
                color="grey.light"
                boxSize="6"
                marginLeft="12px"
              />
              <Icon
                type="EmailOpen"
                boxSize="6"
                color="grey.light"
                marginLeft="12px"
              />
              <Icon
                type="MoreVertical"
                color="grey.light"
                boxSize="6"
                marginLeft="12px"
              />
              <Icon
                type="Store"
                boxSize="6"
                color="grey.light"
                marginLeft="12px"
              />
            </Box>
          </Flex>
          <Divider marginTop="16px" />
          <Box
            flexDirection="column"
            display="flex"
            justifyContent="center"
            height="105px"
            alignItems="center"
          >
            <IconButton
              borderRadius="32px"
              marginLeft="8px"
              fillColor="green.base"
              iconSize="2em"
              borderWidth="0px"
              size="md"
              type="MobilePhone"
              tabIndex="-1"
            />
            <Text fontWeight="semibold" fontSize="lg">
              Beginning of text message conversation
            </Text>
            <Text color="grey.lighter">Wednesday, Dec 8, 2021 at 3:27 PM</Text>
          </Box>
          <Box width="100%" padding="16px">
            <Flex alignItems="end" justifyContent="start">
              <Box
                float="right"
                textAlign="left"
                padding="12px 20px"
                display="inline-block"
                maxWidth="54%"
                overflowWrap="break-word"
                lineHeight="1.4"
                fontSize="14px"
                position="relative"
                borderRadius="16px 16px 16px 4px"
                backgroundColor="silver.light"
              >
                <Text color="grey.base">
                  Hi, tester. Welcome to Podium! To help you get started, we've
                  added some quick setup tasks, shown on the right side of the
                  screen, that will help you get the most out of Podium. And if
                  you'd like to dig into all Podium has to offer, you can
                  schedule time with a member of our sales team.
                </Text>
              </Box>
            </Flex>
          </Box>
        </Box>
        <Box
          border="1px solid rgb(228, 233, 240)"
          borderRadius="8px"
          height="105px"
          width="calc(100% - 32px)"
          backgroundColor="white"
          marginLeft="16px"
          marginBottom="32px"
          padding="24px 24px 16px 24px"
          position="absolute"
          bottom="0px"
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
        >
          <Flex flex="1" justifyContent="space-between">
            <Icon boxSize="5" type="FaceHappy" />
          </Flex>
          <Flex justifyContent="space-between">
            <Flex alignItems="center">
              <Icon marginLeft="-2px" boxSize="5" type="PaperClip" />
              <Icon marginLeft="16px" boxSize="5" type="Calendar" />
              <Icon marginLeft="16px" boxSize="5" type="StarAdd" />
              <Icon
                marginTop="4px"
                marginLeft="16px"
                boxSize="5"
                type="Payments"
              />
            </Flex>
            <ButtonGroup size="sm" spacing="4">
              <Button disabled>Send & Close</Button>
              <Button fillColor="blue.base" tabIndex="-1">
                Send
              </Button>
            </ButtonGroup>
          </Flex>
        </Box>
      </Flex>
    </>
  );
};

export default FakeConversation;
